import PropTypes from "prop-types"
import React, { useState, useEffect, useMemo } from "react"
import moment from "moment-timezone"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import Switch from "react-switch"
import "react-datepicker/dist/react-datepicker.css"
import { statusTypes, roleType, messageTitle } from "constants/common"
import { emailRegex } from "../../helpers/validator"
import Select from "react-select"
// actions
import {
  addNewAdmin as onAddNewAdmin,
  updateAdmin as onUpdateAdmin,
  clearMessage as onClearMessage,
} from "store/admin/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { dateformat, timezone } from "config"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { isEmpty } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

const data = {
  system_management: [
    { key: "tickets", name: "Tickets", selected: true },
    { key: "manage_admins", name: "Manage Admins", selected: true },
    { key: "system_settings", name: "System Settings", selected: true },
  ],
  app_user_management: [
    { key: "manage_approval", name: "Manage Approval", selected: true },
    { key: "manage_roles", name: "Manage Roles", selected: true },
    { key: "manage_users", name: "Manage Users", selected: true },
    { key: "manage_guest", name: "Manage Guest", selected: true },
    { key: "manage_bills", name: "Manage Bills", selected: true },
    { key: "manage_blacklists", name: "Manage Blacklists", selected: true },
  ],
  carpark_management: [
    {
      key: "manage_season_passes",
      name: "Manage Season Passes",
      selected: true,
    },
    { key: "manage_carparks", name: "Manage Carparks", selected: true },
   /*  {
      key: "manage_special_dates",
      name: "Manage Special Dates",
      selected: true,
    }, */
  ],
}
const AdminCreate = props => {
  const { isEdit } = props
  const dispatch = useDispatch()
  const { admin, setSelectedAdmin, toggle, isOpen } = props
  const [controls, setControls] = useState({ ...data })
  // Form validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: admin?.email || "",
      name: admin?.name || "",
      //controls: admin?.controls || {},
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please enter email")
      .matches(emailRegex,"Invalid email address" ),
      name: Yup.string().required("Please enter name"),
    }),
    onSubmit: values => {
      let adminObj = {
        name: values["name"],
        email: values["email"],
        controls: controls,
      }

      // Check If Edit mode
      if (!isEmpty(admin)) {
        adminObj = {
          ...adminObj,
          status: admin?.status || "Approved",
          id: admin._id,
        }
        dispatch(onUpdateAdmin(adminObj))
      } else {
        dispatch(onAddNewAdmin(adminObj))
      }
      //setSelectedAdmin({})
    },
  })

  useEffect(() => {
    if (admin && !isEmpty(admin)) {
      validation.initialValues = {
        name: admin?.name || "",
        email: admin?.email || "",
        //controls: admin?.controls || {},
      }
      setControls({ ...(admin?.controls || data) })
    }
  }, [])

  const { error, message } = useSelector(state => ({
    error: state.admins.error,
    message: state.admins.message,
  }))

  useMemo(() => {
    if (message) {
      toastr.success(message, messageTitle)
      toggle()
      setTimeout(() => {
        dispatch(onClearMessage())
      }, 500)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(
        error?.message || "Oops..Something went wrong.",
        messageTitle
      )
      setTimeout(() => {
        dispatch(onClearMessage())
      }, 500)
    }
  }, [dispatch, error])

  const handleOnChange = (e, type, key) => {
    const { checked } = e.target
    const newControl = [...controls[type]]
    const index = newControl.findIndex(obj => obj.key === key)
    if (index > -1) {
      newControl[index]["selected"] = checked
    }
    //setControls(obj => ({ ...obj, [type]: newControl }))
    setControls(prevState => {
      let newState = { ...prevState }
      newState[type] = [...newControl]
      return newState
    })
  }

  const handleOnSelectAll = (e, type) => {
    const { checked } = e.target
    let newControl = [...controls[type]]
    if (!checked) {
      newControl = newControl.map(opt => ({ ...opt, selected: false }))
    } else {
      newControl = newControl.map(opt => ({ ...opt, selected: true }))
    }
    //setControls(obj => ({ ...obj, [type]: [...newControl] }))
    setControls(prevState => {
      let newState = { ...prevState }
      newState[type] = [...newControl]
      return newState
    })
  }

  const renderCheckboxList = (options, type) => {
    const list = options.map((opt, i) => (
      <div className="form-check mt-2" key={`key_` + opt.key + i}>
        <label>
          <input
            key={`chk__` + opt.key}
            type="checkbox"
            name={opt.key}
            className="form-check-input"
            onChange={e => handleOnChange(e, type, opt.key)}
            //defaultValue={opt.selected}
            //checked={opt.selected}
            defaultChecked={opt.selected}
          />
          <Label className="form-check-label" htmlFor={`key_` + type + i}>
            {opt.name}
          </Label>
        </label>
      </div>
    ))
    return list
  }

  const renderSwitch = type => {
    switch (type) {
      case "system_management":
        return "System Management"
      case "app_user_management":
        return "App User Management"
      case "carpark_management":
        return "Carpark Management"
    }
  }

  const renderSelectAllCheckbox = type => (
    <div className="form-check ps-0 mt-2" key={`div__${type}`}>
    {/*   <label>
        <input
          key={`chk__${type}`}
          type="checkbox"
          //className="form-check-input"
          onChange={e => handleOnSelectAll(e, type)}
          defaultChecked={controls[type].every(opt => opt.selected)}
        />
      </label> */}
      <Label
        className="form-check-label font-size-14 mb-3 ms-1"
        htmlFor={`chk__${type}`}
      >
        {renderSwitch(type)}
      </Label>
    </div>
  )

  return (
    <Modal isOpen={isOpen} toggle={toggle} className={"modal-lg"}>
      <ModalHeader toggle={toggle} tag="h4">
        {admin ? "Update Admin" : "Add New Admin"}
      </ModalHeader>
      <ModalBody>
        <React.Fragment>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row form>
              <Col xs={12}>
                <Row>
                  <Col md={6}>
                    <div className="mb-2">
                      <Label className="form-label">Email*</Label>
                      <Input
                        name="email"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-2">
                      <Label className="form-label">Name*</Label>
                      <Input
                        name="name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  {Object.keys(controls).map((type, index) => (
                    <Col md={4} key={`col_key_` + index}>
                      {renderSelectAllCheckbox(type)}
                      {renderCheckboxList(controls[type], type)}
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button type="submit" className="btn btn-success save-user">
                    {admin ? "Update Admin" : "Add Admin"}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </React.Fragment>
      </ModalBody>
    </Modal>
  )
}

export default AdminCreate
AdminCreate.propTypes = {
  history: PropTypes.object,
  admin: PropTypes.object,
  setSelectedAdmin: PropTypes.func,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  isEdit: PropTypes.bool,
}
